/* eslint-disable no-extra-parens */
import { WbStatePrivacyCookieKey } from '../../components/common/interfaces/types';
import { 
    appNexusMagnitePrebidScripts,
    identityHubInlineScript
} from './constants';

import { useEffect, useRef, useState } from 'react';
import { loadScriptsAsync } from '../../components/common/utilities/loadScriptsAsync/loadScriptsAsync';
import { getStatePrivacyPolicyCookie } from '../../common/utilities/ccpaHelper';

export const useAdScriptLoader = (shouldLoadAdScript: boolean) => {
    const [scriptsLoaded, setScriptsLoaded] = useState(false);
    const mountedRef = useRef(false);
    const isLoadComplete = useRef(false);

    useEffect(() => {
        const queryParams = new URLSearchParams(window.location.search);
        const sQueryParamValue = queryParams.get('s');
        if (sQueryParamValue || isLoadComplete.current || !shouldLoadAdScript) {
            return;
        }
        mountedRef.current = true;

        (async() => {
            const statePrivacyCookie = getStatePrivacyPolicyCookie(WbStatePrivacyCookieKey);
            isLoadComplete.current = true;
            if (statePrivacyCookie?.doNotSell || statePrivacyCookie?.limitUseOfPI) {
                // load only pbjs and xandr scripts - Opt out signals present in cookies
                const { scriptsLoadSuccess: xandrPrebidScriptsLoaded } = await loadScriptsAsync(appNexusMagnitePrebidScripts);
                if (mountedRef.current) {
                    setScriptsLoaded(xandrPrebidScriptsLoaded);   
                }
            } else {
                // load Identity Hub Scripts First - No opt out cookies
                const { scriptsLoadSuccess: identityHubLoaded } = await loadScriptsAsync(identityHubInlineScript);

                if (identityHubLoaded && mountedRef.current) {
                    // loaded Identity Hub scripts - attempt loading Xandr and Pbjs scripts
                    const { scriptsLoadSuccess: xandrPrebidScriptsLoaded } = await loadScriptsAsync(appNexusMagnitePrebidScripts);
                    if (mountedRef.current) {
                        setScriptsLoaded(xandrPrebidScriptsLoaded);   
                    }
                } else { // fallback to normal behavior, couldn't load Identity Hub scripts
                    const { scriptsLoadSuccess: xandrPrebidScriptsLoaded } = await loadScriptsAsync(appNexusMagnitePrebidScripts);
                    if (mountedRef.current) {
                        setScriptsLoaded(xandrPrebidScriptsLoaded);   
                    }
                }
            }
        })();

        return () => {
            mountedRef.current = false;
        };
    }, [shouldLoadAdScript]);

    return scriptsLoaded;
};
